import { render, staticRenderFns } from "./RecordsStandardTable.vue?vue&type=template&id=337d2aa4"
import script from "./RecordsStandardTable.vue?vue&type=script&lang=js"
export * from "./RecordsStandardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports